<template>
  <!-- <Popup
    :title="title"
    :visible="visible"
    :singleBtn="false"
    :customFooter="true"
    :width="'100%'"
    style="height:100%"
    @popupCancle="handleCancel"
    class="modalPopup"
  > -->
  <a-modal
    title="接口授权"
    :visible="visible"
    width="100%"
    @cancel="handleCancel"
  >
    <div style="height: 100%">
      <a-tabs :activeKey="currentKey" @change="tabChange">
        <a-tab-pane :key="1" tab="接口授权">
          <a-transfer
            show-search
            :data-source="allList"
            :titles="['未授权接口', '已授权接口']"
            :list-style="{
              width: '48%',
              height: '70vh',
            }"
            :rowKey="(record) => record.interfaceId"
            :target-keys="targetKeys"
            :render="
              (item) =>
                `${item.serviceName} - ${item.interfaceName} - ${item.interfacePath}`
            "
            @change="handleChange"
            @search="handleSearch"
          />
        </a-tab-pane>
        <a-tab-pane :key="2" tab="接口控制" force-render>
          <!-- <a-form v-if="isShow" :form="form"> -->
          <a-form-model ref="ruleForm" :model="authList" :rule="rules">
            <a-table
              ref="table"
              size="middle"
              bordered
              :rowKey="(record) => record.id"
              :columns="columns"
              :dataSource="authList.list"
              :pagination="false"
              :loading="loading"
              class="j-table-force-nowrap"
            >
              <a-form-model-item
                slot="rateLimitType"
                slot-scope="text, record, index"
              >
                <a-radio-group
                  v-model="record.rateLimitType"
                  @change="handleSelect(record, index)"
                >
                  <a-radio :value="0"> 不限制 </a-radio>
                  <a-radio :value="2"> 静态 </a-radio>
                  <a-radio :value="1"> 动态 </a-radio>
                </a-radio-group>
              </a-form-model-item>
              <a-form-model-item
                slot="rate"
                slot-scope="text, record, index"
                :prop="'list.' + index + '.rate'"
                :rules="rules.rate1"
                v-if="record.rateLimitType == 0"
              >
                <a-input-number v-model="record.rate" :min="1" disabled />
              </a-form-model-item>
              <a-form-model-item
                v-else
                slot="rate"
                slot-scope="text, record, index"
                :prop="'list.' + index + '.rate'"
                :rules="rules.rate"
              >
                <a-input-number
                  v-model="record.rate"
                  :min="1"
                  :disabled="record.rateLimitType == 0"
                />
              </a-form-model-item>
              <a-form-model-item
                slot="rateUnit"
                slot-scope="text, record, index"
                :prop="'list.' + index + '.rateUnit'"
                :rules="rules.rateUnit1"
                v-if="record.rateLimitType == 0"
              >
                <a-select
                  style="width: 120px"
                  v-model="record.rateUnit"
                  disabled
                >
                  <a-select-option value="分钟"> 分钟 </a-select-option>
                  <a-select-option value="小时"> 小时 </a-select-option>
                  <a-select-option value="天"> 天 </a-select-option>
                  <a-select-option value="周"> 周 </a-select-option>
                  <a-select-option value="月"> 月 </a-select-option>
                </a-select>
              </a-form-model-item>
              <a-form-model-item
                v-else
                slot="rateUnit"
                slot-scope="text, record, index"
                :prop="'list.' + index + '.rateUnit'"
                :rules="rules.rateUnit"
              >
                <a-select style="width: 120px" v-model="record.rateUnit">
                  <a-select-option value="分钟"> 分钟 </a-select-option>
                  <a-select-option value="小时"> 小时 </a-select-option>
                  <a-select-option value="天"> 天 </a-select-option>
                  <a-select-option value="周"> 周 </a-select-option>
                  <a-select-option value="月"> 月 </a-select-option>
                </a-select>
              </a-form-model-item>
              <span slot="isEncrypt" slot-scope="text, record">
                <a-switch
                  :disabled="encryptDisable == 1 ? false : true"
                  :checked="handleCheck('isEncrypt', record.isEncrypt)"
                  checked-children="是"
                  un-checked-children="否"
                  @change="(checked) => onChange(checked, 'isEncrypt', record)"
                />
              </span>
              <span slot="isLog" slot-scope="text, record">
                <a-switch
                  :disabled="logDisable == 1 ? false : true"
                  :checked="handleCheck('isLog', record.isLog)"
                  checked-children="是"
                  un-checked-children="否"
                  @change="(checked) => onChange(checked, 'isLog', record)"
                />
              </span>
            </a-table>
          </a-form-model>
        </a-tab-pane>
      </a-tabs>
    </div>
    <template slot="footer">
      <a-button type="primary" @click="submitComBtn">{{ btnComTxt }}</a-button
      ><a-button type="primary" :loading="loadingFlg" @click="submitBtn">{{
        btnTxt
      }}</a-button></template
    >
  </a-modal>
  <!-- </Popup> -->
</template>
<script>
import { postAction, getAction, jsonAction } from '@/api/manage';
import Popup from '@/components/common/Popup';
import customRender from '@/utils/customRender.js';

export default {
  name: 'ImpowerModal',
  components: {
    Popup,
  },

  data() {
    let validatorRate = (rule, value, callback) => {
      // 如果为空值，就抛出错误
      if (!value) {
        callback(new Error('请输入频率!'));
      } else {
        callback();
      }
    };
    let validatorRateUnit = (rule, value, callback) => {
      console.warn(value);

      if (!value) {
        callback(new Error('请选择单位!'));
      } else if (value == '-') {
        callback(new Error('请选择单位!'));
      } else {
        callback();
      }
    };
    return {
      isShow: false,
      rules: {
        rate: [{ validator: validatorRate, trigger: 'blur' }],
        rate1: [{ trigger: 'blur' }],
        rateUnit: [{ validator: validatorRateUnit, trigger: 'blur' }],
        rateUnit1: [{ trigger: 'blur' }],
      },
      form: this.$form.createForm(this),
      isShowCom: true,
      loading: false,
      btnComTxt: '取消',
      allList: [],
      targetKeys: [],
      form: this.$form.createForm(this),
      title: '操作',
      visible: false,
      // 表头
      columns: [
        {
          title: '服务',
          align: 'center',
          dataIndex: 'serviceName',
          customRender: customRender,
          width: 150,
          ellipsis: true,
        },
        {
          title: '接口名',
          align: 'center',
          dataIndex: 'interfaceName',
          customRender: customRender,
          width: 150,
          ellipsis: true,
        },
        {
          title: '接口地址',
          align: 'center',
          dataIndex: 'interfacePath',
          customRender: customRender,
          width: 300,
          ellipsis: true,
        },
        {
          title: '频率限制类型',
          align: 'center',
          dataIndex: 'rateLimitType',
          width: 300,
          scopedSlots: { customRender: 'rateLimitType' },
        },

        {
          title: '频率',
          align: 'center',
          dataIndex: 'rate',
          width: 200,
          scopedSlots: { customRender: 'rate' },
        },
        {
          title: '单位',
          align: 'center',
          dataIndex: 'rateUnit',
          width: 200,
          scopedSlots: { customRender: 'rateUnit' },
        },
        {
          title: '加密',
          align: 'center',
          dataIndex: 'isEncrypt',
          width: 100,
          scopedSlots: { customRender: 'isEncrypt' },
        },
        {
          title: '记录日志',
          align: 'center',
          dataIndex: 'isLog',
          width: 100,
          scopedSlots: { customRender: 'isLog' },
        },
      ],
      url: {
        allList: process.env.VUE_APP_CMS_SYSTEM + '/sys/auth/interface/list',
        auth: process.env.VUE_APP_CMS_SYSTEM + '/sys/auth/app/interface',
        hasAuth:
          process.env.VUE_APP_CMS_SYSTEM + '/sys/auth/app/interface/beList',
      },
      currentKey: 1,
      authList: {
        list: [],
      },
      btnTxt: '保存&下一步',
      loadingFlg: false,
      logDisable: false,
      encryptDisable: false,
    };
  },
  watch: {
    currentKey(val) {
      if (val == 2) {
        this.initHasAuth();
      }
    },
  },
  mounted() {
    console.warn(this.authList);
  },
  methods: {
    initData() {
      this.allList = [];

      getAction(this.url.allList, {
        systemId: this.recordId,
      }).then((res) => {
        if (res.success) {
          console.warn(res);
          if (res.result && res.result.length > 0) {
            res.result.forEach((item) => {
              item.title = item.interfaceName;
              this.allList.push(item);
              // if (item.isAuth == 1) {
              //   this.targetKeys.push(item.interfaceId);
              // }
            });

            this.filterList(this.allList);
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },
    tabChange(key) {
      this.currentKey = key;
      this.btnTxt = '保存&下一步';
      if (key == 2) {
        this.btnTxt = '完成';
        this.initHasAuth();
      }
    },
    handleSelect(record, index) {
      if (record.rateLimitType == 0) {
        this.authList.list[index].rate = '';
        this.authList.list[index].rateUnit = '-';
      }
    },
    handleChange(targetKeys, direction, moveKeys) {
      console.log(targetKeys, direction, moveKeys);
      this.targetKeys = targetKeys;
    },

    filterList(arr) {
      let keys = [];
      let obj = arr.find((item) => item.isAuth == 1);
      console.log(obj, '>>>>>>>>>x');
      console.warn(arr);
      arr.forEach((item) => {
        if (item.isAuth == 1) {
          keys.push(item.interfaceId);
        }
      });
      this.targetKeys = keys;
      console.warn(this.targetKeys, 'this.targetKeys');
    },
    handleSearch(dir, value) {
      console.log('search:', dir, value);
    },
    add(record) {
      this.visible = true;
      this.currentKey = 1;
      this.isShowCom = true;
      this.btnTxt = '保存&下一步';

      this.recordId = record.id;
      this.logDisable = record.isLog;
      this.encryptDisable = record.isEncrypt;
      this.$nextTick(() => {
        this.initData();
      });
    },
    nextStep(type) {
      let list = {
        list: [],
        systemId: this.recordId,
      };

      this.targetKeys.forEach((item) => {
        let target = this.allList.find((ele) => ele.interfaceId == item);
        console.warn(target);
        if (target) {
          target.systemId = this.recordId;
          list.list.push(target);
        }
      });
      this.loadingFlg = true;
      jsonAction(this.url.auth, list, 'post').then((res) => {
        this.loadingFlg = false;
        if (res.success) {
          this.$message.success('授权成功');
          if (type == 0) {
            this.currentKey = 2;
            this.btnTxt = '完成';
            this.isShowCom = false;
          }
        }
      });
    },
    submitComBtn() {
      this.visible = false;
    },
    submitBtn() {
      if (this.currentKey == 1) {
        this.nextStep(0);
      } else {
        if (this.authList.list.length > 0) {
          let list = {
            list: this.authList.list,
            systemId: this.authList.list[0].systemId,
          };
          // console.warn(this.authList.list);
          this.$refs.ruleForm.validate((valid) => {
            if (valid) {
              this.loading = true;
              this.loadingFlg = true;
              jsonAction(this.url.auth, list, 'post').then((res) => {
                this.loading = false;
                this.loadingFlg = false;
                if (res.success) {
                  this.$message.success('授权成功');
                  this.initHasAuth();
                  this.visible = false;
                } else {
                  this.$message.success(res.message);
                }
              });
            } else {
              console.log('error submit!!');
              return false;
            }
          });
        } else {
          this.visible = false;
        }
      }
    },
    initHasAuth() {
      let params = {
        pageNo: 1,
        pageSize: 1000,
        systemId: this.recordId,
      };
      this.loading = true;
      getAction(this.url.hasAuth, params).then((res) => {
        this.loading = false;
        if (res.success) {
          res.result.map((item) => {
            if (item.rate == null) {
              item.rate = '';
            }
            item.rate = item.rate + '';
          });
          this.authList.list = res && res.result ? res.result : [];
          this.isShow = true;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    onChange(checked, flg, record) {
      let target = this.authList.list.find((item) => item.id == record.id);
      target[flg] = checked ? 1 : 0;
      console.log(checked, flg, record);
    },

    handleCancel() {
      this.visible = false;
    },
    handleOk() {
      this.visible = false;
    },
    handleCheck(flg, val) {
      if (flg == 'isEncrypt') {
        return this.encryptDisable == 1 ? (val == 0 ? false : true) : false;
      } else {
        return this.logDisable == 1 ? (val == 0 ? false : true) : false;
      }
    },
  },
};
</script>
<style lang="less" scoped>
// /deep/.ant-modal-centered .ant-modal {
//   height: 100%;
// }
/deep/.ant-modal {
  top: 0;
  height: 100%;
  padding: 0;
}
/deep/ .ant-table {
  height: 70vh;
  overflow: auto;
}

/deep/.ant-modal-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
</style>
